import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../../../../redux/actions/auth/authActions';
import { useTheme } from '../../../../../contexts/ThemeContext';

function ProfileTab({ onClose }) {
  const dispatch = useDispatch();
  const user = useSelector((s) => s.auth.user);
  const { theme } = useTheme();
  const displayName = user?.respondentName || user?.name || "User";

  const handleLogout = () => {
    dispatch(logoutUser());
    onClose();
  };

  return (
    <div style={{ ...styles.card, backgroundColor: theme.surface, borderColor: theme.border }}>
      <div style={{ ...styles.userInfo, borderBottomColor: theme.border }}>
        <div style={{ ...styles.avatar, backgroundColor: theme.primary }}>
          {displayName.charAt(0).toUpperCase() || '?'}
        </div>
        <div>
          <div style={{ fontWeight: 600, color: theme.text, fontSize: '0.9rem' }}>{displayName}</div>
          <div style={{ fontSize: '0.75rem', color: theme.textSecondary }}>{user?.email || ''}</div>
        </div>
      </div>
      <button
        onClick={handleLogout}
        style={{ ...styles.logoutBtn, color: theme.danger, ':hover': { backgroundColor: theme.danger + '10' } }}
      >
        Log out
      </button>
    </div>
  );
}

const styles = {
  card: {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    right: 0,
    width: 220,
    borderRadius: 12,
    border: '1px solid',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
    zIndex: 200,
    overflow: 'hidden',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 16,
    borderBottom: '1px solid',
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontWeight: 600,
    fontSize: '1rem',
    flexShrink: 0,
  },
  logoutBtn: {
    width: '100%',
    padding: '10px 16px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: 500,
    textAlign: 'left',
  },
};

export default ProfileTab;
